
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eagleshare-insurance-and-protection-plan",
      function () {
        return require("private-next-pages/eagleshare-insurance-and-protection-plan.js");
      }
    ]);
  